<template>
  <d-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    backend-sorting
    :default-sort="[pagination.sortField, pagination.sortOrder]"
    striped
    :show-detail-icon="showDetailIcon"
    default-sort-direction="desc"
    :per-page="pagination.pageSize"
    :detailed="detailed"
    @page-change="page => pagination.page = page"
    @sort="onSort"
  >
    <template slot-scope="{ row, index }">
      <slot :row="row" :index="index" />
    </template>
    <template slot="detail" slot-scope="{ row, index }">
      <slot name="detail" :row="row" :index="index" />
    </template>
    <template slot="empty">
      <slot name="empty" />
    </template>
  </d-table>
</template>

<script>
  import debounce from 'lodash/debounce';
  import axios from 'axios';
  import DTable from '../../elements/DTable/DTable.vue';

  /**
   * @displayName DServerTable
   */

  export default {
    name: 'DServerTable',
    components: { DTable },
    props: {
      color: {
        type: String,
        default: 'primary-500',
      },

      showDetailIcon: {
        type: Boolean,
        default: true,
      },

      filter: String,
      fetchEndpoint: String,
      noDebounce: Boolean,
      detailed: Boolean,
      pageSize: {
        type: Number,
        default: 50,
      },
      sortField: {
        type: String,
        default: 'createdAt',
      },
      sortOrder: {
        type: String,
        default: 'desc',
      },
      extraParams: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        data: [],
        loading: false,
        total: 0,
        pagination: {
          page: 1,
          pageSize: this.pageSize,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        },
      };
    },

    watch: {
      pagination: {
        handler() {
          this.getPaged();
        },
        deep: true,
      },

      filter() {
        this.loading = true;
        this.debounceGetPaged();
      },
    },

    mounted() {
      this.getPaged();
    },

    methods: {
      async getPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`];
        const newParams = [...params, ...this.extraParams];
        this.loading = true;
        const { data } = await axios.get(`${this.fetchEndpoint}?${newParams.join('&')}`);
        this.data = data.resultItems;
        this.total = data.totalRecords;
        this.loading = false;
      },

      // eslint-disable-next-line func-names
      debounceGetPaged: debounce(function () {
        this.getPaged();
      }, 500),

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

    },
  };
</script>